<script>
import { BaseStoryCardElementMixin } from "%/dynamic-component-editor/standard-components/base-story-card/base-story-card-element-mixin";
import { DurationElementMixin }
  from "%/dynamic-component-editor/standard-elements/text-element/duration-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";

export default {
  name: "EstimatedReadingTime",
  elementPanelSettings: {
    displayName: "Estimated Reading Time",
    displayIcon: "ic:outline-schedule",
    elementGroup: "storyElements",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [BaseStoryCardElementMixin, DurationElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      const formatted = this.formattedDuration(this.entity.estimatedReadingSeconds);
      const duration = formatted === "" ? "1 min" : formatted;
      return `${duration} read`;
    },
  },
};
</script>
